export enum NodeConfigurationType {
  Agent = -1,
  None = 0,
  Runtime = 1,
  Api = 2,
  WebClient = 3,
  Ldap = 4,
  TestsClient = 5,
  BatchWatcher = 6,
  Scheduler = 7,
  Tracer = 8,
  InMemory = 9,
  Batcher = 10,
  InstanceRepair = 11
}
